package com.example.positionahead.model

import kotlinx.serialization.Serializable

enum class AlertType {
    PRICE_ABOVE,
    PRICE_BELOW,
    GAIN_ABOVE_PCT,
    LOSS_BELOW_PCT,
}

@Serializable
data class PriceAlert(
    val id: String,
    val symbol: String,
    val type: AlertType,
    val threshold: Double,
    val enabled: Boolean = true,
    val triggeredAt: String? = null,
    val read: Boolean = false,
    val note: String = "",
)
